module.exports = __webpack_public_path__ + "fontawesome-webfont.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = ../../../../../src/scss/icons/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module chunks = styles